import { useContext, useEffect, useState } from "react";
import { Box, Container, Button, CircularProgress, Grid, Grow, Paper } from "@mui/material";
import { useQuery, useQueryClient, useMutation } from "react-query";
import { useTranslation } from "react-i18next";
import { getAll, updateStyle } from "./services/api";
import { SnackbarGlobal } from "components/Snackbar";
import DesignMenuOptions from "./modules/DesignMenuOptions";
import { ValidationSchemaStyle } from "./services/schemaValidation";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import MenusList from "./modules/MenusList";
import { FMPageOpacityTransition } from "components/FMTransitions/PageTransitions";
import { AuthContext } from "context/AuthContext";
import { MenuDesignModules } from "./modules";
import Preview from "./preview";
import DialogMenuImageManager from "routes/ImageManager/DialogMenuImageManager";
import { getFonts } from "services/api/GoogleFontsApi";
import { BranchOfficeSelectOnPage } from "components/BranchOfficesSelect/BranchOfficeSelect";

export default function MenuDesign() {
  const { t } = useTranslation();
  const { branchOfficeSelected } = useContext(AuthContext)
  const [isLoading, setIsLoading] = useState(false)
  const [dataFilter, setDataFilter] = useState(null)
  const [dataInstance, setDataInstance] = useState({})
  const [imageManagerModalOpen, setImageManagerModalOpen] = useState(false)
  const [dataFieldImageManager, setDataFieldImageManager] = useState(null)
  const [notification, setNotification] = useState({ open: false, message: "", severity: "" })
  const [instanceSelected, setInstanceSelected] = useState(null)
  const [styleOption, setStyleOption] = useState(0);
  const [menus, setMenus] = useState([])
  const queryClient = useQueryClient()
  const { data } = useQuery('menusDesignList', getAll, { refetchOnWindowFocus: false })
  let { reset, handleSubmit, register, formState: { errors }, setValue } = useForm({
    resolver: yupResolver(ValidationSchemaStyle)
  })
  const { data: dataFonts } = useQuery('fontsList', getFonts, { refetchOnWindowFocus: false })
  const [googleFonts, setGoogleFonts] = useState([])

  useEffect(() => {
    queryClient.invalidateQueries('menusDesignList')
    setInstanceSelected(null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branchOfficeSelected])

  useEffect(() => {
    if (data !== undefined && data !== null && data !== "") {
      setDataFilter(data.data)
      document.addEventListener("wheel", function (event) {
        if (document.activeElement.type === "number") { document.activeElement.blur(); }
      });
    }
  }, [data])

  useEffect(() => {
    if (dataFonts !== undefined && dataFonts !== null && dataFonts !== "") {
      let googleFonts = dataFonts.items.map((item) => { return { value: item.family, label: item.family, } })
      console.log(googleFonts)
      setGoogleFonts(googleFonts)
    }
  }, [dataFonts])

  const handleSetInstanceSelected = (item) => {
    setInstanceSelected(item)
    setDataInstance(item.style)
    reset(item.style)
  }

  const mutation = useMutation(updateStyle, {
    onSuccess: (data) => {
      setIsLoading(false)
      if (data.status === "error") { handleWatchAction(false, 'Error al guardar los datos', 'error') } 
      else {
        handleCancelUpdateStyle()
        handleRefreshData()
        handleWatchAction(true, 'Acción realizada correctamente', 'success')
      }
    }
  })

  const handleUpdateStyle = (params) => {
    params.foodPresentation = dataInstance.foodPresentation
    params.drinkPresentation = dataInstance.drinkPresentation
    setIsLoading(true)
    mutation.mutate({ id: instanceSelected._id, params })
  }

  const handleCancelUpdateStyle = () => {
    setInstanceSelected(null)
    setDataInstance({})
    reset()
    setStyleOption(0)
  }

  const handleRefreshData = () => { queryClient.invalidateQueries('menusDesignList') }
  const handleWatchAction = (success, message, severity) => {
    setNotification({ open: true, message: message, severity: severity })
    if (success) { handleRefreshData() }
  }

  const handleChangeStyleOption = (event) => { setStyleOption(event.target.value) }

  /* Handlers change data */
  const handleOnChangeData = (event) => {
    if (event.target.name.includes(".")) {
      const separate = event.target.name.split(".")
      setDataInstance({ ...dataInstance, [separate[0]]: { ...dataInstance[separate[0]], [separate[1]]: event.target.value } })
      return;
    }
    setDataInstance({ ...dataInstance, [event.target.name]: event.target.value })
  }

  /*Handlers Image manager */
  const handleOpenImageManager = () => { setImageManagerModalOpen(true) }
  const handleCloseImageManager = (prop) => { setImageManagerModalOpen(prop) }
  const handleFieldImageManager = (prop) => { setDataFieldImageManager(prop) }
  const handleSelectImageManager = (url) => {
    setDataInstance({ ...dataInstance, [dataFieldImageManager]: url })
    setValue(dataFieldImageManager, url)
  }

  /* onChange ColorPicker */
  const handleChangeCompletePicker = (color, field) => {
    setDataInstance({ ...dataInstance, [field]: color.hex })
    setValue(field, color.hex)
  }

  /* onChange ColorGradientPicker */
  const handleChangeCompleteGradientPicker = (color, field) => {
    setDataInstance({ ...dataInstance, [field]: color })
    setValue(field, color)
  };

  const handleChangeDataBoolean = (data) => { setDataInstance({ ...dataInstance, [data]: !dataInstance[data] }) }

  if (branchOfficeSelected === null) { return <BranchOfficeSelectOnPage /> }

  return (<>
    <FMPageOpacityTransition>
      <Box component="main" style={{ marginBottom: 100 }}>
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
          {branchOfficeSelected !== null ? <>
            {instanceSelected === null ? <>
              <MenusList t={t} data={dataFilter} selectInstance={handleSetInstanceSelected} menus={menus} setMenus={setMenus} /> </> :
              <Grow in={instanceSelected !== null}>
                <Grid container spacing={1}>
                  <Grid item xs={12} md={12}>
                    <Paper sx={{ padding: 3 }}>
                      <DesignMenuOptions
                        instance={instanceSelected}
                        styleOption={styleOption}
                        handleChangeStyleOption={handleChangeStyleOption}
                        returnBack={handleCancelUpdateStyle} />
                      <MenuDesignModules
                        t={t}
                        styleOption={styleOption}
                        dataInstance={dataInstance}
                        googleFonts={googleFonts}
                        register={register}
                        errors={errors}
                        handleOnChangeData={handleOnChangeData}
                        handleFieldImageManager={handleFieldImageManager}
                        handleOpenImageManager={handleOpenImageManager}
                        handleChangeCompletePicker={handleChangeCompletePicker}
                        handleChangeDataBoolean={handleChangeDataBoolean}
                        handleChangeCompleteGradientPicker={handleChangeCompleteGradientPicker}
                      />
                      {styleOption !== 0 ?
                        <div style={{ display: "flex", justifyContent: "flex-end", gap: 16, marginTop: 16 }}>
                          {!isLoading ? <>
                            <Button variant="outlined" onClick={handleCancelUpdateStyle}>{t('button_text_cancel')}</Button>
                            <Button variant="contained" onClick={handleSubmit(handleUpdateStyle)} >{t('button_text_save')}</Button>
                          </> : <CircularProgress />}
                        </div> :
                        <div style={{ display: "flex", justifyContent: "flex-end", gap: 16, marginTop: 16 }}>
                          <Button variant="outlined" onClick={handleCancelUpdateStyle}>{t('button_text_cancel')}</Button>
                        </div>
                      }
                    </Paper>
                  </Grid>
                  {/* <Grid item xs={12} md={5}> {styleOption !== 0 ? <Preview data={dataInstance} styleOption={styleOption}/> : null} </Grid> */}
                </Grid>
              </Grow>
            } </> : null}
        </Container>
      </Box>
      <DialogMenuImageManager 
        open={imageManagerModalOpen}
        menu={instanceSelected !== null ? instanceSelected._id : 0} 
        actionClose={handleCloseImageManager} 
        setImageSelected={handleSelectImageManager} />
    </FMPageOpacityTransition>
    <SnackbarGlobal open={notification.open} close={() => setNotification({ open: false, message: "", severity: "" })} message={notification.message} severity={notification.severity} />
  </>)
}